module.exports = __webpack_public_path__ + "img/ewm8.16c0fa35.jpg";